
import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Welcome from './components/pages/Welcome';
import Contactus from './components/pages/Contactus';
import NareshChandraDas from './components/pages/NareshChandraDas';
import VideoGallery from './components/pages/VideoGallery';
import MrAmitavaGuha from './components/pages/MrAmitavaGuha';
import DrSankarPrasadDutta from './components/pages/DrSankarPrasadDutta';
import Mission from './components/pages/Mission';
import Facilities from './components/pages/Facilities';
import Vision from './components/pages/Vision';
import Awards from './components/pages/Awards';
import Coscholastics from './components/pages/Coscholastics';
import Aboutus from './components/pages/Aboutus';
import AbriefHistory from './components/pages/AbriefHistory';
import Visiting from './components/pages/Visiting';

import TrustR from './components/pages/TrustR';
import AcademicCalendar from './components/pages/AcademicCaneldar';
import Schooltiming from './components/pages/Schooltiming';
import CritariaAdmission from './components/pages/CritariaAdmission';
import Documentsreq from './components/pages/Documentsreq';
import Admissiontest from './components/pages/Admissiontest';

import MorningPrayer from './components/pages/MorningPrayer';
import Rules from './components/pages/Rules';
import NoObjection from './components/pages/NoObjection';
import Recognition from './components/pages/Recognition';
import FireSafety from './components/pages/FireSafety';
import Deocertificate from './components/pages/Deocertificate';
import Affiliation from './components/pages/Affiliation';
import PressRelease from './components/pages/PressRelease';

import NewRPage from './components/pages/NewRPage';
import Listofsmc from './components/pages/Listofsmc';
import Boardreslut from './components/pages/Boardresult';
import PtaMembers from './components/pages/PtaMembers';
import Structural from './components/pages/Structural';
import Drinking from './components/pages/Drinking';
import LandDocument from './components/pages/LandDocument';
import PublicDis from './components/pages/PublicDis';
import TeachingMethod from './components/pages/TeachingMethod';
import Booklist from './components/pages/Booklist';
import PrePrimary from './components/pages/PrePrimary';
import SeniorSec from './components/pages/SeniorSec';
import Photogallery from './components/pages/Photogallery';
import AdmissionProcedure from './components/pages/AdmissionProcedure';
import Ourteam from './components/pages/Ourteam';
// import ClassX from './components/pages/ClassX';
// import ClassIII from './components/pages/ClassIII';
import RameshKumar from './components/pages/RameshKumar';
import MsIndraniBhattacharyya from './components/pages/MsIndraniBhattacharyya';
import SangaChakraborty from './components/pages/SangaChakraborty';
import FeesStructure from './components/pages/FeesStructure';
import Syllabus from './components/pages/Syllabus';
import SubjectCombination from './components/pages/SubjectCombination';


function App() {
  return (
    <Router>

      <div>



        <Routes>


          <Route axact path="/" element={<Home />} />
          <Route axact path="welcome" element={<Welcome />} />
          <Route axact path="contactus" element={<Contactus />} />
          <Route axact path="NareshChandraDas_chairman" element={<NareshChandraDas />} />
          <Route axact path="Mr.AmitavaGuha_director" element={<MrAmitavaGuha />} />
          <Route axact path="Dr.SankarPrasadDutta_Principal" element={<DrSankarPrasadDutta />} />
          <Route axact path="video-gallery" element={<VideoGallery />} />
          <Route axact path="mission" element={<Mission />} />
          <Route axact path="facilities" element={<Facilities />} />
          <Route axact path="Vision" element={<Vision />} />
          <Route axact path="Awards-recognition" element={<Awards />} />
          <Route axact path="Co-scholastics" element={<Coscholastics />} />
          <Route axact path="aboutus" element={<Aboutus />} />
          <Route axact path="brief-History" element={<AbriefHistory />} />
          <Route axact path="Visiting-hours" element={<Visiting />} />
       
          <Route axact path="trust-registration" element={<TrustR />} />
          <Route axact path="Academic-calendar" element={<AcademicCalendar />} />
          <Route axact path="School&class-timing" element={<Schooltiming />} />
          <Route axact path="Criteria-ofAdmission" element={<CritariaAdmission />} />
          <Route axact path="Documentsrequired" element={<Documentsreq />} />
          <Route axact path="Admissiontest-interview" element={<Admissiontest />} />
          {/* <Route axact path="Agecriteria-forAdmisiion" element={<Agecriteria />} /> */}
          <Route axact path="Morning-Prayer" element={<MorningPrayer />} />
          <Route axact path="rulesandregulations" element={<Rules />} />
          <Route axact path="NoObjection-certificate" element={<NoObjection />} />
          <Route axact path="Recognition-certificate" element={<Recognition />} />
          <Route axact path="Firesafety" element={<FireSafety />} />
          <Route axact path="deocertificate" element={<Deocertificate />} />
          <Route axact path="Affiliation-letter" element={<Affiliation />} />
          <Route axact path="PressRelease" element={<PressRelease />} />
          <Route axact path="NewRealites" element={<NewRPage />} />
          <Route axact path="Listofsmc" element={<Listofsmc />} />
          <Route axact path="boardreslut" element={<Boardreslut />} />
          <Route axact path="PtaMembers" element={<PtaMembers />} />
          <Route axact path="Structural-Stability" element={<Structural />} />
          <Route axact path="Drinkingwater-Sanitation" element={<Drinking />} />
          <Route axact path="LandDocument" element={<LandDocument />} />
          <Route axact path="Mandatory-PublicDisclosure" element={<PublicDis />} />
          <Route axact path="Teaching-learningMethod" element={<TeachingMethod />} />
          <Route axact path="Booklist" element={<Booklist />} />
          <Route axact path="Pre-Primary" element={<PrePrimary />} />
          <Route axact path="SeniorSecondary" element={<SeniorSec />} />
          <Route axact path="Photogallery" element={<Photogallery />} />
          <Route axact path="admission-procedure" element={<AdmissionProcedure />} />
          <Route axact path="Ourteam" element={<Ourteam />} />
          {/* <Route axact path="Harshita-Singh" element={<ClassX />} />
          <Route axact path="Anish-Narotra" element={<ClassIII />} /> */}
            <Route axact path="Dr.RameshKumarAgarwal" element={<RameshKumar/>} />
             <Route axact path="MsIndraniBhattacharyya" element={<MsIndraniBhattacharyya/>} />
              <Route axact path="SangaChakraborty" element={<SangaChakraborty/>} />
              <Route axact path="FeesStructure" element={<FeesStructure/>} />
              <Route axact path="syllabus" element={<Syllabus/>}/>
                  <Route axact path="SubjectCombination_class_XI" element={<SubjectCombination/>}/>
        </Routes>
        <Footer />

      </div>

    </Router>
  );
}

export default App;
